import React, {FC} from 'react';
import Button from 'components/Button';
import {Section as Query} from 'templates/reports/query';
import {Section as Config} from 'templates/reports/types';

import ColorBar from './ColorBar';
import Stats from './Stats';

import * as styles from './styles.module.scss';

export interface InfoCardProps {
	card: Config['details']['card'] | undefined
	data: Query | undefined
	reverse?: boolean
}

export const onScrollTo = (anchor: string) => () => {
	const elem = document.getElementById(anchor);
	if (elem) {
		elem.scrollIntoView({
			behavior: 'smooth',
		});
	}
};

const InfoCard: FC<InfoCardProps> = ({card,	data, reverse}) => {
	if (!card || !data || !data.results.length) return null;
	return (
		<div className={styles.wrapper}>
			<div className={styles.top}>
				<Button variant='underline' onClick={onScrollTo(data.metric)}>
					<div className={styles.title}>
						{card.title}
					</div>
				</Button>
				<Stats
					cfgs={card}
					curr={data.results[0]}
					prev={data.results[1]}
				/>
			</div>
			<div className={styles.bottom}>
				<div className={styles.description}>
					{card.description(
						data.results[0].percentile,
						!!reverse,
						data.historicals?.[0]?.breakpoints,
					)}
				</div>
				{data.historicals.length > 0 && (
					<ColorBar
						breaks={data.historicals[0].breakpoints}
						percentile={data.results[0].percentile}
						reverse={reverse}
					/>
				)}
			</div>
		</div>

	);
};

export default InfoCard;
